import { useState, useEffect } from 'react';
import supabase from '../lib/supabase';

/**
 * Custom hook to fetch platform statistics
 * @returns {Object} stats and loading state
 */
export const useStats = () => {
  const [stats, setStats] = useState({
    patriots: '24,847',
    lessons: '378',
    events: '1,293',
    candidates: '412'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true);
      setError(null);
      try {
        // Try to fetch stats from Supabase
        const { data, error } = await supabase
          .from('platform_stats')
          .select('stat_name, stat_value');

        if (error) throw error;

        // If we have data, format it
        if (data && data.length > 0) {
          const formattedStats = {
            patriots: formatNumber(data.find(stat => stat.stat_name === 'republican_patriots')?.stat_value || '24847'),
            lessons: formatNumber(data.find(stat => stat.stat_name === 'constitutional_lessons')?.stat_value || '378'),
            events: formatNumber(data.find(stat => stat.stat_name === 'gop_events_monthly')?.stat_value || '1293'),
            candidates: formatNumber(data.find(stat => stat.stat_name === 'republican_candidates')?.stat_value || '412')
          };
          setStats(formattedStats);
        }
      } catch (err) {
        console.error('Error fetching stats:', err);
        setError(err.message);
        // We keep the default stats if there's an error
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  // Helper function to format numbers with commas
  const formatNumber = (num) => {
    if (!num) return '0';
    return parseInt(num).toLocaleString('en-US');
  };

  return { stats, loading, error };
};